import React from 'react';

const ClassroomContext = React.createContext(/**@type {IClassroomContext} */ (undefined));

export default ClassroomContext;

// TODO: add other types
/**
 * @typedef {object} IClassroomContext
 * @property {CourseData | null | undefined} courseData
 * @property {string | null} currentSubsectionId
 * @property {string | null} currentSubsectionReferId
 * @property {*} refreshCourseData
 * @property {*} updateCurrentSubsection
 * @property {*} classroomCourseId
 * @property {*} classroomTimeId
 * @property {*} courseId
 * @property {*} isEnableVideoResume
 * @property {*} updateIsEnableVideoResume
 * @property {LayoutType} layoutType
 * @property {(layoutType: LayoutType) => void} updateLayout
 * @property {*} bookmarkProgress
 * @property {*} updateBookmarkProgress
 * @property {*} isAutoPlayVideo
 * @property {*} updateIsAutoPlayVideo
 * @property {*} initClassroom
 * @property {boolean} hasClassroomSession
 * @property {*} userProfileData
 * @property {*} updateUserProfileData
 * @property {*} isConcurrent
 * @property {*} updateIsConcurrent
 * @property {LearningMode} currentLearningMode
 * @property {(learningMode: LearningMode) => void} setCurrentLearningMode
 * @property {boolean} isUnauthorizedUser
 * @property {(isUnauthorizedUser: boolean) => void} handleSetUnauthorizedUser
 * @property {*} logoutCallback
 * @property {Map<string, string>} subsectionIdSourceMissionIdMapper
 */

/**
 * @typedef {Object} CourseData
 * @property {string} courseTitle
 * @property {string} courseRevision
 * @property {"TRIAL"|"FULL"} courseClassroomMode
 * @property {string} courseSourceType
 * @property { string[] | null } courseLearningModes
 * @property {{ id: string; name:string; isActive: boolean }[] | null } courseLearningModeDetails
 * @property {boolean} isSectionGroupActive
 * @property {SectionGroup[]} sectionGroups
 * @property {Section[]} sections
 * @property {FlattedSubsection[]} subsections
 * @property {string[]} completedSubsectionsIds
 * @property {{ [subsectionId: string]: LearningMode[] | true }} learningModeCompletedSubsectionIds
 * @property {FlattedSubsection} inProgressSubsection
 * @property {object} sectionThemeColor
 * @property {string|null} partnerLogoUrl
 * @property {string[]} failedSubsectionIds
 * @property {string[]} submittedSubsectionIds
 * @property {string | null} courseMode
 * @property {TableOfContentTungkai | null | undefined} tableOfContentTungkai
 */

/**
 * @typedef {{
    id: string;
    title: string;
    referId: string;
    contentType: string;
    isVirtual: boolean;
    sections: Section[];
  }} SectionGroup
 *
 * @typedef {
    {
      id: string;
      title: string;
      referId: string;
      subSections: Subsection[]
 * } Section
 *
 * @typedef {{
    id: string;
    title: string;
    contentType: "VIDEO" | "ARTICLE" | "ASSIGNMENT" | "LIVECODING" | "LIVE_VIDEO" | "VIDEO_SLIDE" | "QUIZ" | "QUIZ_SIMPLE" | "NOTEBOARD" | "FULL_LESSON" | "SUMMARY_LESSON" | "EBOOK";
    referId: string;
    canPreview: boolean;
    releasedAt: Date | null;
    isLock: boolean;
    meta: {
      videoTime: number | null;
    };
    learningModes: string[] | null;
  }} Subsection
 *
 * @typedef {Subsection & { sectionId: string }} FlattedSubsection
 */

/**
 * @typedef {{
    id: string;
    sections: TableOfContentTungkaiSection[];
  }} TableOfContentTungkai
 *
 * @typedef {{
    id: string;
    title: string;
    referId: string;
    missions: Mission[];
  }} TableOfContentTungkaiSection
 *
 * @typedef {{
    id: string;
    referId: string;
    title: string;
    meta: {
      missionType: string;
    };
    subSections: Subsection[];
  }} Mission
 */

/**
 * @typedef {import("./constant").LearningMode} LearningMode
 * @typedef {import("./constant").LayoutType} LayoutType
 */
